package site.shadadman.pages.worklog.StrAIberry

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initStrAIberryPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/StrAIberry/StrAIberry.md", FrontMatterElement.Builder { addScalar("title", "StrAIberry Worklog"); }))
}

@Page("/worklog/StrAIberry/str-a-iberry")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun StrAIberryPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("straiberry") }) {
        org.jetbrains.compose.web.dom.Text("StrAIberry")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/dec152021StraAIberryFirstSprint") {
                org.jetbrains.compose.web.dom.Text("First Sprint")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/jan102022StrAIberryBaseArchDecision") {
                org.jetbrains.compose.web.dom.Text("Base Architecture Decision")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/march22022StrAIberryAGreatTDD") {
                org.jetbrains.compose.web.dom.Text("A Great TDD")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/may82022StrAIberryChartChallenges") {
                org.jetbrains.compose.web.dom.Text("Chart Challenges")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/sep182022StrAIberryLiveDetectionChallenge") {
                org.jetbrains.compose.web.dom.Text("Live Detection Challenge")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/nov22022StrAuberryJawIllustrationChallenge") {
                org.jetbrains.compose.web.dom.Text("Jaw Illustration Challenge")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/apr22023StrAIberryCalendarChallenge") {
                org.jetbrains.compose.web.dom.Text("Calendar Challenge")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/mar82024StrAIberryAdvancedCheckup") {
                org.jetbrains.compose.web.dom.Text("Advanced Checkup")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/jul162024StrAIberryChangingCameraFocus") {
                org.jetbrains.compose.web.dom.Text("Changing Camera Focus")
            }
        }
    }
}
